// extracted by mini-css-extract-plugin
export default {"container":"AskEmail_container__89HK2","title":"AskEmail_title__bkhaf","text":"AskEmail_text__qMPFo","colorLinkEn":"AskEmail_colorLinkEn__ApBj3"};